// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorData from "./ErrorData.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

function giftStatusLabelFun(giftStatusLabel) {
  switch (giftStatusLabel) {
    case "Cancelled" :
        return /* Cancelled */5;
    case "Delivered" :
        return /* Delivered */0;
    case "Delivering" :
        return /* Sending */8;
    case "Failed" :
        return /* Failed */2;
    case "Opened" :
        return /* Opened */1;
    case "Pending" :
        return /* Pending */4;
    case "Resending" :
        return /* Resending */3;
    case "Scheduled" :
        return /* Scheduled */6;
    default:
      return /* Completed */7;
  }
}

function giftFailedDeliveryFun(strs) {
  return Belt_Array.keepMap(strs, (function (str) {
                var match = str.toLowerCase();
                switch (match) {
                  case "email" :
                      return /* Email */0;
                  case "phone" :
                      return /* Phone */1;
                  default:
                    return ;
                }
              }));
}

function theme(json) {
  return {
          uid: Json_decode.field("uid", Json_decode.string, json),
          thumbImage: Json_decode.field("thumb_image", Json_decode.string, json),
          squareIcon: Json_decode.field("square_icon", Json_decode.string, json),
          textureImage: Json_decode.field("texture_image", Json_decode.string, json),
          title: Json_decode.field("title", Json_decode.string, json)
        };
}

function providerDetails(json) {
  return {
          videoId: Json_decode.field("video_id", Json_decode.string, json),
          accountId: Json_decode.field("account_id", Json_decode.string, json),
          playerId: Json_decode.field("player_id", Json_decode.string, json)
        };
}

function media(json) {
  return {
          uid: Json_decode.field("uid", Json_decode.string, json),
          mediaType: Json_decode.field("media_type", Json_decode.string, json),
          provider: Json_decode.field("provider", Json_decode.string, json),
          providerDetails: Json_decode.field("provider_details", providerDetails, json)
        };
}

function gift(json) {
  return {
          uid: Json_decode.optional((function (param) {
                  return Json_decode.field("uid", Json_decode.string, param);
                }), json),
          recipientName: Json_decode.field("recipient_name", Json_decode.string, json),
          recipientEmail: Json_decode.field("recipient_email", Json_decode.string, json),
          recipientPhone: Json_decode.field("recipient_phone", Json_decode.string, json),
          scheduledDeliveryAt: Json_decode.optional((function (param) {
                  return Json_decode.field("scheduled_delivery_at", Json_decode.string, param);
                }), json),
          recipientTimezone: Json_decode.optional((function (param) {
                  return Json_decode.field("recipient_timezone", Json_decode.string, param);
                }), json),
          giftStatusLabel: giftStatusLabelFun(Json_decode.field("gift_status_label", Json_decode.string, json)),
          giftFailedDelivery: giftFailedDeliveryFun(Json_decode.field("gift_failed_delivery", (function (param) {
                      return Json_decode.array(Json_decode.string, param);
                    }), json)),
          resendGiftNotificationUrl: Json_decode.field("resend_gift_notification_url", Json_decode.string, json),
          updateGiftScheduledDeliveryUrl: Json_decode.field("update_gift_scheduled_delivery_url", Json_decode.string, json),
          message: Json_decode.field("message", Json_decode.string, json),
          theme: Json_decode.field("theme", theme, json),
          media: Json_decode.field("media", (function (param) {
                  return Json_decode.array(media, param);
                }), json)
        };
}

function card(json) {
  return {
          themeImage: Json_decode.optional((function (param) {
                  return Json_decode.field("theme_image", Json_decode.string, param);
                }), json),
          expiry: Json_decode.optional((function (param) {
                  return Json_decode.field("expiry", Json_decode.string, param);
                }), json),
          value: Json_decode.field("value", Json_decode.string, json),
          valueCurrency: Json_decode.optional((function (param) {
                  return Json_decode.field("value_currency", Json_decode.string, param);
                }), json),
          uid: Json_decode.field("sku_uid", Json_decode.string, json),
          skuDisplayName: Json_decode.optional((function (param) {
                  return Json_decode.field("sku_display_name", Json_decode.string, param);
                }), json),
          categories: Json_decode.optional((function (param) {
                  return Json_decode.field("categories", (function (param) {
                                return Json_decode.array(Json_decode.string, param);
                              }), param);
                }), json),
          category: Json_decode.optional((function (param) {
                  return Json_decode.field("category", Json_decode.string, param);
                }), json),
          skuSlug: Json_decode.field("sku_slug", Json_decode.string, json),
          skuUid: Json_decode.optional((function (param) {
                  return Json_decode.field("sku_uid", Json_decode.string, param);
                }), json),
          gift: Json_decode.optional((function (param) {
                  return Json_decode.field("gift", gift, param);
                }), json),
          skuDefaultSwap: Json_decode.optional((function (param) {
                  return Json_decode.field("sku_default_swap", Json_decode.string, param);
                }), json)
        };
}

function order(json) {
  var orderStatus = Json_decode.field("status", Json_decode.string, json);
  var tmp = orderStatus === "completed" ? /* Completed */0 : /* Cancelled */1;
  return {
          uid: Json_decode.field("uid", Json_decode.string, json),
          number: Json_decode.field("number", Json_decode.string, json),
          createdAt: Json_decode.field("created_at", Json_decode.string, json),
          scheduledDeliveryAt: Json_decode.optional((function (param) {
                  return Json_decode.field("scheduled_delivery_at", Json_decode.string, param);
                }), json),
          amount: Json_decode.field("amount", Json_decode.string, json),
          amountCurrency: Json_decode.field("amount_currency", Json_decode.string, json),
          status: tmp,
          isBuyForYourself: Json_decode.field("is_buy_for_yourself", Json_decode.bool, json),
          invoiceUrl: Json_decode.field("invoice_url", Json_decode.string, json),
          paymentMethod: Json_decode.optional((function (param) {
                  return Json_decode.field("payment_method", Json_decode.string, param);
                }), json),
          cards: Json_decode.field("cards", (function (param) {
                  return Json_decode.array(card, param);
                }), json)
        };
}

function orders(json) {
  return {
          count: Json_decode.field("count", Json_decode.$$int, json),
          next: Json_decode.field("next", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          previous: Json_decode.field("previous", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          results: Json_decode.field("results", (function (param) {
                  return Json_decode.array(order, param);
                }), json),
          pageNumber: Json_decode.field("page_number", Json_decode.$$int, json),
          pageSize: Json_decode.field("page_size", Json_decode.$$int, json)
        };
}

function safeDecodeOrderData(json) {
  var result;
  try {
    result = orders(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return ErrorData.Decode.safeDecodeError(json);
    }
    throw exn;
  }
  return {
          TAG: /* Ok */0,
          _0: result
        };
}

function safeDecodeOrderDetailsData(json) {
  var result;
  try {
    result = order(json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return ErrorData.Decode.safeDecodeError(json);
    }
    throw exn;
  }
  return {
          TAG: /* Ok */0,
          _0: result
        };
}

var Decode = {
  theme: theme,
  providerDetails: providerDetails,
  media: media,
  gift: gift,
  card: card,
  order: order,
  orders: orders,
  safeDecodeOrderData: safeDecodeOrderData,
  safeDecodeOrderDetailsData: safeDecodeOrderDetailsData
};

function dtoToDataItem(res) {
  var orders = Belt_Array.concatMany(Belt_Array.keepMap(res.results, (function (order) {
              return Belt_Array.map(Belt_Array.keepMap(order.cards, (function (card) {
                                if (!order.isBuyForYourself && Belt_Option.isNone(card.gift)) {
                                  return ;
                                } else {
                                  return card;
                                }
                              })), (function (card) {
                            return {
                                    uid: order.uid,
                                    number: order.number,
                                    createdAt: order.createdAt,
                                    scheduledDeliveryAt: order.scheduledDeliveryAt,
                                    amount: order.amount,
                                    amountCurrency: order.amountCurrency,
                                    status: order.status,
                                    invoiceUrl: order.invoiceUrl,
                                    paymentMethod: order.paymentMethod,
                                    defaultCard: card
                                  };
                          }));
            })));
  return {
          count: res.count,
          orders: orders,
          page: res.pageNumber,
          pageSize: res.pageSize
        };
}

function sortTypesToString(type_) {
  switch (type_) {
    case /* DateDesc */0 :
        return "DateDesc";
    case /* DateAsc */1 :
        return "DateAsc";
    case /* Az */2 :
        return "az";
    case /* Za */3 :
        return "za";
    
  }
}

var Data = {
  dtoToDataItem: dtoToDataItem,
  sortTypesToString: sortTypesToString
};

export {
  giftStatusLabelFun ,
  giftFailedDeliveryFun ,
  Decode ,
  Data ,
}
/* No side effect */
